import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class CDNService {
    getCDNBilling(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/optionnalcdn/billing',
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getCDNsData(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/optionnalcdndata',
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getCDNs(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/optionnalcdn',
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


    postCDN(Name, OriginUrl, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/optionnalcdn',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: {
                    Name,
                    OriginUrl
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    updateCDN(ID, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/optionnalcdn/' + ID,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    purgeCDN(id, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/optionnalcdn/' + id + "/purge",
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putCDN(id, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/optionnalcdn/' + id,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteCDN(id, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/optionnalcdn/' + id,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }
}